// extracted by mini-css-extract-plugin
export default {"contractName":"ContractName_contractName__fRI-Z","contractDescription":"ContractName_contractDescription__rp7xx"};